import React from 'react'
import { map, get } from 'lodash'

import { __ } from '~/i18n'
import { PaymentMethod } from '~/components/payment'

export default class MakeCommerceMethod extends React.PureComponent {
  render() {
    const { data, paymentMethod, active, selectMethod, args, showProvider } = this.props;

    if(!data) {
      return null;
    }

    const { banklinks } = data;
    const selectedBankLinkName = get(args, 'name');

    return map(banklinks, (bankLink) => {
      let props = {};
      const bankLinkSelected = active && (selectedBankLinkName === bankLink.name);

      if(bankLink.logo_url) {
        props.image = bankLink.logo_url
      }else {
        props.name = bankLink.name.toUpperCase()
      }

      if(showProvider) {
        props.extra = __('Maksekeskus')
      }
      return (
        <PaymentMethod
          key={ bankLink.name }
          active={ bankLinkSelected }
          {...props}
          selectMethod={ () => {
            selectMethod(paymentMethod, bankLink);
          }}
        />
      )
    })
  }
}
